import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { imgUrl, eur } from "../../lib/api";
import { useCart } from "../../context/CartContext";
import { useLang } from "../../context/LangContext";
import { StockBadge } from "./StockBadge";
import { CardBackArt } from "./CardBackArt";
import { useStore } from "../../context/StoreContext";
import { Clock } from "lucide-react";
import { LangBadge } from "./Flag";
import { langName } from "../../lib/editions";

export const ProductCard = ({ p, i = 0 }) => {
  const { add } = useCart();
  const { t, pname, lang } = useLang();
  const { prelaunch } = useStore();
  const soldOut = p.stock <= 0;
  return (
    <div data-testid={`product-card-${p.slug}`} style={{ animationDelay: `${i * 60}ms` }}
      className="fade-up group relative bg-white rounded-2xl border border-[#120E1F]/[0.07] overflow-hidden hover:border-[#F2C230]/60 hover:shadow-[0_20px_50px_-20px_rgba(18,14,31,0.25)] transition-[border-color,box-shadow] duration-300">
      <Link to={`/product/${p.slug}`} className="block">
        <div className="relative aspect-[4/5] overflow-hidden bg-[#F7F5FB]">
          {prelaunch ? <CardBackArt label={t("coming_soon_short")} tilt={((i % 3) - 1) * 4} /> : (
            <img src={imgUrl(p.images?.[0])} alt={pname(p)} loading="lazy"
              className={`h-full w-full object-cover transition-transform duration-700 group-hover:scale-105 ${soldOut ? "grayscale opacity-60" : ""}`} />)}
          <div className="holo absolute inset-0 pointer-events-none" />
          <div className="absolute top-3 left-3 flex gap-1.5">
            <LangBadge code={p.language} testid={`card-lang-${p.slug}`} />
            {p.preorder && <span className="tag">{lang === "en" ? "Pre-order" : "Vorbestellung"}</span>}
          </div>
        </div>
      </Link>
      <div className="p-4 sm:p-5 space-y-3">
        <p className="text-[11px] uppercase tracking-[0.18em] text-[#707783]">{p.set_name}</p>
        <p className="text-xs text-[#6E3FB8] -mt-2" data-testid={`card-type-${p.slug}`}>{t("cat")[p.category]}{langName(p.language, lang) ? ` (${langName(p.language, lang)})` : ""}</p>
        <Link to={`/product/${p.slug}`}><h3 className="font-medium text-[#120E1F] leading-snug line-clamp-2 min-h-[2.75rem] hover:text-[#6E3FB8] transition-colors">{pname(p)}</h3></Link>
        {prelaunch ? (
          <p className="flex items-center gap-2 text-sm font-semibold text-[#6E3FB8] pt-1" data-testid={`coming-soon-${p.slug}`}><Clock className="h-4 w-4 text-[#F2C230]" />{t("coming_soon")}</p>
        ) : (<>
        <StockBadge stock={p.stock} testid={`stock-badge-${p.slug}`} />
        <div className="flex items-end justify-between pt-1">
          <div>
            <p className="font-mono text-lg font-semibold text-[#120E1F]" data-testid={`price-${p.slug}`}>{eur(p.price)}</p>
            <p className="text-[10px] text-[#707783]">{t("vat")}</p>
          </div>
          <button data-testid={`quick-add-${p.slug}`} disabled={soldOut}
            onClick={() => { add(p); toast.success(t("added")); }}
            className="h-10 w-10 rounded-full bg-[#120E1F] text-[#C9B6F2] grid place-items-center hover:bg-[#F2C230] hover:text-[#120E1F] disabled:opacity-30 disabled:cursor-not-allowed transition-colors active:scale-95">
            <Plus className="h-4 w-4" />
          </button>
        </div>
        </>)}
      </div>
    </div>
  );
};
